import React from 'react';
import PropTypes from "prop-types";
import Button from '../../components/Button';
import Api from '../../Api';

export default class AdminBar extends React.Component {
  static propTypes = {
    className: PropTypes.string
  };

  constructor(props) {
    super(props);

    this.refreshData = this.refreshData.bind(this);

    this.state = {
      retailer: Api.cache.getRetailer(),
      isVisible: Api.cache.getAdminBarVisible(),
      data: null,
    };
  }

  componentWillMount() {
    Api.startListen(this, 'isVisible', Api.cache.eventTypes.ADMIN_BAR_VISIBILITY_CHANGED);
    Api.cache.addChangeListener(this.refreshData, Api.cache.eventTypes.RETAILER_CHANGED)
  }

  componentWillUnmount() {
    Api.stopListen(this, Api.cache.eventTypes.ADMIN_BAR_VISIBILITY_CHANGED);
    Api.cache.removeChangeListener(this.refreshData, Api.cache.eventTypes.RETAILER_CHANGED);
  }

  componentDidMount() {
    this.refreshData();
  }

  refreshData() {
    Api.internalRecommendations().then(
        (response) => {
          this.setState({
            data: response
          });
        },
        (error) => {
          this.setState({error});
        }
    );
  }

  render() {
    let classNames = ['admin-bar'];
    if (this.props.className && this.props.className !== '') classNames.push(classNames);

    let carriedCategories;
    let crawledImages;

    if (this.state.data) {
      carriedCategories =
          <div>
            <h2>Known Carried Categories</h2>
            <p>{this.state.data.carried_categories.join(', ')}</p>
          </div>;

      if (this.state.data.crawled_images && this.state.data.crawled_images.length > 0) {
        let style = {
          width: "auto",
          height: "100px"
        };
        let images = this.state.data.crawled_images
            .map(
              (image, index) => <img key={`admin-bar-image-${image.url}-${index}`}
                       src={image.url} style={style}
                       role="presentation"/>
            );
        crawledImages = <div><h2>Crawled Images</h2><p>{images}</p></div>;
      }
    }

    return (
        <div className={classNames.join(' ')}>
          {carriedCategories}
          <AdminBarFilter />
          {crawledImages}
        </div>
    );
  }
}

class AdminBarFilter extends React.Component {
  constructor(props) {
    super(props);

    this.updateRecommendationList = this.updateRecommendationList.bind(this);
    this.onChange = this.onChange.bind(this);
    this.selectAll = this.selectAll.bind(this);
    this.selectNone = this.selectNone.bind(this);

    this.state = {
      displayedResults: null,
      availableFilters: [],
      currentFilter: Api.cache.getCurrentRecommendationFilter()
    }
  }

  componentWillMount() {
    Api.cache.addChangeListener(this.updateRecommendationList, Api.cache.eventTypes.CURRENT_RECOMMENDATION_SET_CHANGED);
    Api.startListen(this, 'currentFilter', Api.cache.eventTypes.CURRENT_RECOMMENDATION_FILTER_CHANGED);
    this.updateRecommendationList();
  }

  componentWillUnmount() {
    Api.cache.removeChangeListener(this.updateRecommendationList, Api.cache.eventTypes.CURRENT_RECOMMENDATION_SET_CHANGED);
    Api.stopListen(this, Api.cache.eventTypes.CURRENT_RECOMMENDATION_FILTER_CHANGED);
  }

  updateRecommendationList() {
    let payload = {
      displayedResults: Api.cache.getCurrentRecommendationSet(),
      availableFilters: []
    };

    if (payload.displayedResults) {
      Object.keys(payload.displayedResults.products).forEach(productToken => {
        let product = payload.displayedResults.products[productToken];

        if (product.recommenders) {
          product.recommenders.forEach(recommender => {
            if (payload.availableFilters.indexOf(recommender) < 0) payload.availableFilters.push(recommender);
          });
        }
      });
    }

    this.setState(payload);
  }

  onChange(event) {
    let itemIndex = this.state.currentFilter.indexOf(event.target.value);
    let newFilter = [];
    if (itemIndex < 0) {
      newFilter = [event.target.value, ...this.state.currentFilter];
    } else {
      newFilter = [...this.state.currentFilter.slice(0, itemIndex), ...this.state.currentFilter.slice(itemIndex + 1)];
    }

    Api.cache.setCurrentRecommendationFilter(newFilter);
  }

  selectAll(event) {
    event.preventDefault();
    Api.cache.setCurrentRecommendationFilter([...this.state.availableFilters]);
  }

  selectNone(event) {
    event.preventDefault();
    Api.cache.setCurrentRecommendationFilter([]);
  }

  render() {
    let options = null;

    if (!this.state.availableFilters || this.state.availableFilters.length <= 0) {
      options = <span>No Recommenders</span>;
    } else {
      options = this.state.availableFilters.map(
        filterName =>
          <li key={`admin-filter-${filterName}`}>
            <input type="checkbox" checked={this.state.currentFilter.indexOf(filterName) >= 0} value={filterName}
                   onChange={this.onChange}/>
            {filterName}
          </li>
      );
    }

    return (
      <div className="adminbar-filter-component">
        <h2>Available recommenders</h2>
        <ul>
          {options}
          <li><input type="checkbox" checked={this.state.currentFilter.indexOf('+ACTIVE') >= 0} value="+ACTIVE" onChange={this.onChange} />+ACTIVE</li>
        </ul>
        <div>
          <Button onClick={this.selectAll}>All</Button>
          <Button onClick={this.selectNone}>None</Button>
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/views/admin/AdminBar.js
 **/